<template>
  <div class="charts-container" :id="domId"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  props: ["option","index"],
  data() {
    return {
        domId:'charts-container_'+this.index
    };
  },
  created(){
    this.domId = 'charts-container_'+this.index
  },
  mounted() {
    this.$nextTick(()=>{
        setTimeout(()=>{
            this.init();
        },1000)
    })
    
  },
  methods: {
    init() {
      const chartDom = document.getElementById(this.domId);
      const myChart = echarts.init(chartDom);
      myChart.setOption(this.option);
    },
  },
};
</script>
<style lang="scss" scoped>
.charts-container {
  height: 100%;
  width: 100%;
}
</style>